import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { FaChalkboardTeacher,FaUsers, FaStore, FaMicrophone } from 'react-icons/fa'; // sample icons

import _ from "lodash";
interface AboutProps {
    landingPageData: any; // Replace `any` with the correct type if available
    eventData: any;        // Replace `any` with the correct type if available
  }
const Statistics: React.FC<AboutProps> = ({landingPageData, eventData}) => {

    const exhibitorsCount     = eventData?.exhibitor_count || 0;
    const participantsCount   = eventData?.participant_count || 0;
    const speakersCount       = eventData?.speaker_count || 0;
    const sessionCount        = eventData.sessionsCount ? eventData.sessionsCount : 0;
  
  return (

    <div className="row statistic-area" >
      <div className="col-md-12">
        <div className="row">
          <div className="col-lg-3 col-sm-6">
            <div className="stat-card">
              {/* <FaUsers className="stat-icon" style={{color: landingPageData.button_color}} /> */}
              <div className='stat_content'>
                <h3 className="stat-number">{participantsCount}</h3>
                <p className="stat-title">Participants</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-sm-6">
            <div className="stat-card">
              {/* <FaStore className="stat-icon" style={{color: landingPageData.button_color}} /> */}
              <div className='stat_content'>
                <h3 className="stat-number">{exhibitorsCount}</h3>
                <p className="stat-title">Exhibitors</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-sm-6">
            <div className="stat-card">
              {/* <FaMicrophone className="stat-icon" style={{color: landingPageData.button_color}} /> */}
              <div className='stat_content'>
                <h3 className="stat-number">{speakersCount}</h3>
                <p className="stat-title">Speakers</p>
              </div>
            </div>
          </div>

           <div className="col-lg-3 col-sm-6">
            <div className="stat-card">
              {/* <FaChalkboardTeacher className="stat-icon"  style={{color: landingPageData.button_color}}/> */}
              <div className='stat_content'>
                <h3 className="stat-number">{sessionCount}</h3>
                <p className="stat-title">Sessions</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  
  );
};

export default Statistics;

